// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "OnboardingForm__textCenter__qBex6";
export const onboardingFormWrapper = "OnboardingForm__onboardingFormWrapper__fdxPl";
export const onboardingForm = "OnboardingForm__onboardingForm__kXlsJ";
export const cardLayout = "OnboardingForm__cardLayout__Lh-zE";
export const controlList = "OnboardingForm__controlList__kbVQe";
export const controlListItem = "OnboardingForm__controlListItem__7I3hS";
export const submitListItem = "OnboardingForm__submitListItem__cd2mI";
export const rowButtonListItem = "OnboardingForm__rowButtonListItem__OCRIg OnboardingForm__controlListItem__7I3hS";
export const buttonContainer = "OnboardingForm__buttonContainer__X6vHR";
export const innerHeader = "OnboardingForm__innerHeader__aI55v font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const termsInvitation = "OnboardingForm__termsInvitation__dXLlr font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const loginInvitation = "OnboardingForm__loginInvitation__kuVCx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const link = "OnboardingForm__link__UqkNZ";
export const spinnerWrapper = "OnboardingForm__spinnerWrapper__D0him";
export const listArrayItem = "OnboardingForm__listArrayItem__YkKo6";
export const policyLabelLinks = "OnboardingForm__policyLabelLinks__IX0kI";